
export const Data = [
  {
    type:"zh",
    content: {
      boxImg:{
        type:"img",
        urlData:"http://116.62.38.250//image/ykb/nr/cpjs/banner.png"
      },
      menuData:[
          {
            num : {
              type:"text",
              content:"1"
            },
            tital : {
              type:"text",
              content:"口腔Er:YAG激光治疗仪"
            },
            path: {
              type:"text",
              content:"bt1"
            },
          },
        // {
        //   num : {
        //     type:"text",
        //     content:"2"
        //   },
        //   tital : {
        //     type:"text",
        //     content:"智能操作界面"
        //   },
        //   path: {
        //     type:"text",
        //     content:"bt2"
        //   },
        // },
        // {
        //   num : {
        //     type:"text",
        //     content:"3"
        //   },
        //   tital : {
        //     type:"text",
        //     content:"手柄内置激光发生器"
        //   },
        //   path: {
        //     type:"text",
        //     content:"bt3"
        //   },
        // },
        // {
        //   num : {
        //     type:"text",
        //     content:"4"
        //   },
        //   tital : {
        //     type:"text",
        //     content:"激光工作尖"
        //   },
        //   path: {
        //     type:"text",
        //     content:"bt4"
        //   },
        // },
        // {
        //   num : {
        //     type:"text",
        //     content:"5"
        //   },
        //   tital : {
        //     type:"text",
        //     content:"激光全能手机"
        //   },
        //   path: {
        //     type:"text",
        //     content:"bt5"
        //   },
        // },


      ],
      item:[
        {
          type:"box", //boxleft boxrigth boxvideo
          path:"bt1",
          index:"1",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"口腔Er:YAG激光治疗仪",
            },
            text2:{
              type:"text",
              content:"口腔Er:YAG激光治疗仪，采用军工级别的Er:YAG晶体，产生波长为2940nm的激光，通过手机动态聚焦技术与口腔组织中水分子的作用，产生“微爆破”反应，实现口腔软、硬组\n" +
                "织的汽化，消融切割等治疗效果。 \n" +
                "口腔Er:YAG激光对组织表面的温度影响微乎其微，是目前口腔激光治疗领域中高效、安全、微创的治疗方式。 \n" +
                "口腔Er:YAG激光治疗仪，可以广泛应用于口腔治疗的的各个学科，尤其在牙周、种植、正畸、美学、儿牙方面有着明显的临床优势。",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/cpjs/all.png",
            },
            text4:{
              type:"video",
              content:"",
            }
          }
        },
        {
          type:"boxleft", //boxleft boxrigth boxvideo
          path:"bt1",
          index:"2",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"智能操作界面",
            },
            text2:{
              type:"text",
              content:"全中文界面，软硬组织模式轻松切换，人性化可定制模式，实现口腔全科治疗需求，智能操作系统、模块化设计，操作简单，使用高效。",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/cpjs/2right.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        },
        {
          type:"boxrigth", //boxleft boxrigth boxvideo
          path:"bt1",
          index:"3",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"手柄内置激光发生器",
            },
            text2:{
              type:"text",
              content:"激光动态聚焦技术，精准安全；自动脉宽调解保护技术，耐用且高效；自研谐振腔技术，将激光器内置于工作手柄内部，不仅无高昂易损件，且使激光功率传导无损伤，无衰减。",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/cpjs/3left.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        },
        {
          type:"boxleft", //boxleft boxrigth boxvideo
          path:"bt1",
          index:"4",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"激光工作尖",
            },
            text2:{
              type:"text",
              content:"非侵入式设计、吸附锁式设计，即插即用，配备各种直径和长度不同的规格，独创的一次性工作尖，有效避免交叉感染源。",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/cpjs/1right.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        }
        ,
        {
          type:"boxrigth", //boxleft boxrigth boxvideo
          path:"bt1",
          index:"5",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"激光全能手机",
            },
            text2:{
              type:"text",
              content:"直弯头设计，实现全方位多角度诊疗模式，手机可360度旋转，灵活轻巧，减轻医生负担；完全按照医生的使用习惯进行设计。",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/cpjs/4left.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        }
      ],
      homeLeave:{
        text1:{
          type:"",
          content:"留言反馈"
        },
        text2:{
          type:"",
          content:"为您提供咨询服务，与您一起提升口腔激光医学水平"
        },
        text3:{
          type:"",
          content:"400-178-1617"
        },
        text4:{
          type:"",
          content:"info@yacobon.com"
        }
      },
      homeLeavePlace:{
        text1:"姓名",
        text2:"您的手机号",
        text3:"您的微信",
        text4:"留下您的建议和意见",
        commit:"提交"
      }
    }

  },
  {
    type:"en",
    content: {
      boxImg:{
        type:"img",
        urlData:"http://116.62.38.250//image/ykb/nr/cpjs/banner.png"
      },
      menuData:[
        {
          num : {
            type:"text",
            content:"1"
          },
          tital : {
            type:"text",
            content:"Er:YAG Dental Laser Instrument"
          },
          path: {
            type:"text",
            content:"bt1"
          },
        },
        // {
        //   num : {
        //     type:"text",
        //     content:"2"
        //   },
        //   tital : {
        //     type:"text",
        //     content:"智能操作界面"
        //   },
        //   path: {
        //     type:"text",
        //     content:"bt2"
        //   },
        // },
        // {
        //   num : {
        //     type:"text",
        //     content:"3"
        //   },
        //   tital : {
        //     type:"text",
        //     content:"手柄内置激光发生器"
        //   },
        //   path: {
        //     type:"text",
        //     content:"bt3"
        //   },
        // },
        // {
        //   num : {
        //     type:"text",
        //     content:"4"
        //   },
        //   tital : {
        //     type:"text",
        //     content:"激光工作尖"
        //   },
        //   path: {
        //     type:"text",
        //     content:"bt4"
        //   },
        // },
        // {
        //   num : {
        //     type:"text",
        //     content:"5"
        //   },
        //   tital : {
        //     type:"text",
        //     content:"激光全能手机"
        //   },
        //   path: {
        //     type:"text",
        //     content:"bt5"
        //   },
        // },


      ],
      item:[
        {
          type:"box", //boxleft boxrigth boxvideo
          path:"bt1",
          index:"1",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"Er:YAG Dental Laser Instrument",
            },
            text2:{
              type:"text",
              content:"The Er:YAG Dental Laser Instrument adopts a military-grade Er:YAG crystal, which generates a laser with a wavelength of 2940nm. Through the interaction between the dynamic focusing technology of the handpiece and the water molecules in the oral tissues, a \"micro-explosion\" reaction is produced, achieving treatment effects such as vaporization, ablation, and cutting of the oral soft and hard tissues.\n" +
                "\n" +
                "The Er:YAG dental laser has a negligible impact on the temperature of the tissue surface. It is currently an efficient, safe, and minimally invasive treatment method in the field of oral laser treatment.\n" +
                "\n" +
                "The Er:YAG Dental Laser Instrument can be widely applied to various disciplines of oral treatment, especially showing obvious clinical advantages in periodontics, implantation, orthodontics, esthetics, and pediatric dentistry.\n",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/cpjs/all.png",
            },
            text4:{
              type:"video",
              content:"",
            }
          }
        },
        {
          type:"boxleft", //boxleft boxrigth boxvideo
          path:"bt1",
          index:"2",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"Intelligent Operation Interface",
            },
            text2:{
              type:"text",
              content:"With a full Chinese-language interface, it allows for easy switching between soft and hard tissue modes. The humanized customizable mode can meet the treatment needs of general dentistry. The intelligent operation system and modular design make it simple to operate and highly efficient to use.",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/cpjs/2right.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        },
        {
          type:"boxrigth", //boxleft boxrigth boxvideo
          path:"bt1",
          index:"3",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"Laser Generator Built-in the Handpiece",
            },
            text2:{
              type:"text",
              content:"It features the laser dynamic focusing technology, which is precise and safe; the automatic pulse width adjustment protection technology makes it durable and efficient; the self-developed resonant cavity technology integrates the laser generator inside the working handpiece. Not only are there no expensive and vulnerable parts, but also the laser power can be transmitted without damage or attenuation.",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/cpjs/3left.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        },
        {
          type:"boxleft", //boxleft boxrigth boxvideo
          path:"bt1",
          index:"4",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"Laser Working Tips",
            },
            text2:{
              type:"text",
              content:"With a non-invasive design and an adsorption locking design, it is plug-and-play. It is equipped with various specifications of different diameters and lengths. The original one-time working tips can effectively avoid the sources of cross-infection.",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/cpjs/1right.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        }
        ,
        {
          type:"boxrigth", //boxleft boxrigth boxvideo
          path:"bt1",
          index:"5",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"All-round Laser Handpiece",
            },
            text2:{
              type:"text",
              content:"With a straight and bent head design, it realizes an all-round and multi-angle diagnosis and treatment mode. The handpiece can rotate 360 degrees, which is flexible and lightweight, reducing the burden on doctors. It is completely designed according to the doctors' usage habits.",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/cpjs/4left.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        }
      ],
      homeLeave:{
        text1:{
          type:"",
          content:"Message and Feedback"
        },
        text2:{
          type:"",
          content:"We provide you with consultation services and work together with you to enhance the level of oral laser medicine."
        },
        text3:{
          type:"",
          content:"400-178-1617"
        },
        text4:{
          type:"",
          content:"info@yacobon.com"
        }
      },
      homeLeavePlace:{
        text1:"Name",
        text2:"Mobile Phone Number",
        text3:"WeChat ID",
        text4:"Please leave your suggestions and opinions.",
        commit:"Submit"
      }
    }

  },
];



// WEBPACK FOOTER //
// ./src/components/js/product.js